import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HelpCircle, Mail, MessageCircle, X, Clock, BookOpen } from 'lucide-react';

const SupportButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const whatsappLink = "https://wa.me/5534992004667?text=Olá,%20preciso%20de%20suporte%20na%20plataforma%20CERPBrasil.";
  const emailLink = "mailto:suporte@cerpbrasil.com.br";

  const handleHelpCenterClick = () => {
    setIsOpen(false);
    navigate('/ajuda');
  };

  return (
    <div className="fixed bottom-20 right-6 z-[99999]" data-testid="support-button-container">
      {/* Contact Card */}
      {isOpen && (
        <div 
          className="absolute bottom-14 right-0 bg-white rounded-xl shadow-xl border border-slate-200 w-72 overflow-hidden"
          data-testid="support-panel"
        >
          {/* Header */}
          <div className="bg-teal-600 px-4 py-3 flex items-center justify-between">
            <h3 className="font-medium text-white flex items-center gap-2 text-sm">
              <HelpCircle className="h-4 w-4" />
              Suporte CERP Brasil
            </h3>
            <button
              onClick={() => setIsOpen(false)}
              className="p-1 hover:bg-teal-700 rounded transition-colors"
              aria-label="Fechar"
            >
              <X className="h-4 w-4 text-white" />
            </button>
          </div>

          {/* Contact Options */}
          <div className="p-3 space-y-2">
            {/* Central de Ajuda - Nova opção */}
            <button
              onClick={handleHelpCenterClick}
              className="w-full flex items-center gap-3 p-3 bg-violet-50 hover:bg-violet-100 rounded-lg transition-colors text-left"
              data-testid="support-help-center-link"
            >
              <div className="p-2 bg-violet-100 rounded-lg">
                <BookOpen className="h-4 w-4 text-violet-600" />
              </div>
              <div>
                <p className="text-sm font-medium text-slate-800">Central de Ajuda</p>
                <p className="text-xs text-slate-500">Tutoriais e manuais do sistema</p>
              </div>
            </button>

            {/* Email */}
            <a
              href={emailLink}
              className="flex items-center gap-3 p-3 bg-slate-50 hover:bg-slate-100 rounded-lg transition-colors"
              data-testid="support-email-link"
            >
              <div className="p-2 bg-teal-100 rounded-lg">
                <Mail className="h-4 w-4 text-teal-600" />
              </div>
              <div className="min-w-0">
                <p className="text-xs text-slate-500">E-mail</p>
                <p className="text-sm font-medium text-slate-800 truncate">suporte@cerpbrasil.com.br</p>
              </div>
            </a>

            {/* WhatsApp */}
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 p-3 bg-slate-50 hover:bg-green-50 rounded-lg transition-colors"
              data-testid="support-whatsapp-link"
            >
              <div className="p-2 bg-green-100 rounded-lg">
                <MessageCircle className="h-4 w-4 text-green-600" />
              </div>
              <div>
                <p className="text-xs text-slate-500">WhatsApp</p>
                <p className="text-sm font-medium text-slate-800">(34) 99200-4667</p>
              </div>
            </a>
          </div>

          {/* Footer - Hours */}
          <div className="px-4 py-2 bg-slate-50 border-t border-slate-100">
            <p className="text-xs text-slate-500 flex items-center gap-1.5">
              <Clock className="h-3 w-3" />
              Atendimento de Seg a Sex, 8h às 18h
            </p>
          </div>
        </div>
      )}

      {/* Single Floating Button - Green Theme */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`
          p-3 rounded-full shadow-lg transition-colors
          ${isOpen 
            ? 'bg-teal-700 hover:bg-teal-800' 
            : 'bg-teal-600 hover:bg-teal-700'
          }
        `}
        aria-label={isOpen ? 'Fechar suporte' : 'Abrir suporte'}
        data-testid="support-toggle-btn"
      >
        {isOpen ? (
          <X className="h-5 w-5 text-white" />
        ) : (
          <HelpCircle className="h-5 w-5 text-white" />
        )}
      </button>
    </div>
  );
};

export default SupportButton;
